import { useState } from 'react'
import Card from '@mui/joy/Card'
import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import Typography from '@mui/joy/Typography'
import Confetti from 'react-confetti'

export const OnboardingComplete = ({ onNext }) => {
    return (
        <Box>
            <Confetti recycle={false} numberOfPieces={800} />
            <Card sx={{ width: 700 }} variant="outlined" color="neutral">
                <Box
                    sx={{
                        m: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3,
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 2,
                        }}
                    >
                        <Typography level="h2">Welcome to Bruce!</Typography>
                        <Typography
                            level="body-md"
                            sx={{ textAlign: 'center' }}
                        >
                            Our mission to make social media marketing easy for
                            everyone. Are you ready? <br />
                            Let's do this!
                        </Typography>
                        <Box>
                            <iframe
                                id="player"
                                type="text/html"
                                width="640"
                                height="390"
                                src="https://www.youtube.com/embed/XRQWGBbHYq4"
                                frameborder="0"
                            ></iframe>
                        </Box>
                    </Box>
                    <Button sx={{ display: 'flex', flex: 1 }} onClick={onNext}>
                        <div>Get Started</div>
                    </Button>
                </Box>
            </Card>
        </Box>
    )
}
